module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH-1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/authorsnote#aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword#for"
    }
  }, [_vm._v("Foreword by Hillary Johnson")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("Introduction: Navigating by Lymelight")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue#pro"
    }
  }, [_vm._v("Prologue: Second Journey Out")])]), _vm._v(" "), _c('p', {
    staticClass: "CPT"
  }, [_c('span', {
    staticClass: "cpn"
  }, [_vm._v("PART ONE: ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/part1#pt1"
    }
  }, [_c('span', {
    staticClass: "cpn"
  }, [_vm._v("DOORS OF PERCEPTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  1. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("Into the Woods")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  2. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("A Place in the Whirlwind")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  3. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Son of a Preacher Man")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  4. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Connecticut Genesis")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  5. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Disease and a Ring of Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  6. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding Lyme’s Counterculture")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  7. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hide in Plain Sight")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  8. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Epidemic Spreads")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("  9. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crossing the Line")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("10. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rocky Road")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("11. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Then There Were Three")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("12. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Night Falls Fast")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("13. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discovering the Spirochete")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("14. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Chasm Widens")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("15. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Lyme World Split in Two")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("16. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lost in the Ruins: The Infestation of the Suburbs")])]), _vm._v(" "), _c('p', {
    staticClass: "CPT"
  }, [_c('span', {
    staticClass: "cpn"
  }, [_vm._v("PART TWO: ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/part2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cpn"
  }, [_vm._v("THE LYME DIASPORA")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("17. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mutts Like Us: Lyme Tests and Tribulations")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_vm._v("18. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patients Dispossessed")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("19.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scourge of “Lime” Disease")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("20.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peeling the Onion")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("21.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family Therapy")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("22.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bicycle Boy and Other Lymebrains")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("23.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Devastating Realization")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("24.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Longing for Lyme")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("25.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Nantucket Burning: I’m Diagnosed with Babesiosis")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("26.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo Safari")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("27.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tick Menagerie: The Coinfections of Lyme Disease")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("28.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hole in the Donut: The Fight over Southern Lyme")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("29.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Restricting Diagnosis and Keeping the Riffraff Out of Lyme")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("30.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Long Road Home")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("31.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reporting Our Pediatrician")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("32.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lyme Inquisition: Doctors on the Run")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("33.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note from the Underground")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("34.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second-Chance Kids")])]), _vm._v(" "), _c('p', {
    staticClass: "CPT"
  }, [_c('span', {
    staticClass: "cpn"
  }, [_vm._v("PART THREE: ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/part3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "cpn"
  }, [_vm._v("A SEARCH FOR ANSWERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("35.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Once Bitten: Accepting the Spirochete’s Endless Love")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("36.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Secrets of an Evil Genius: The Evidence for Persistence")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("37.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mother Makes Four")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("38.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Big Sleep: Our Younger Son Falls Ill")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("39.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Houston Calling")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("40.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Putting Treatment to the Test")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("41.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Busted Flat in Chappaqua")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("42.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resurrection")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("43.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter43#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lyme Disease and Immunity: The Search for the Golden Fleece")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("44.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter44#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How I Cured My Own Lyme Disease")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("45.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter45#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pay It Forward")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("46.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter46#ch46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Family Affair")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("47.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter47#ch47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red-Flagged at Blue Cross: The Role of Managed Care")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("48.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter48#ch48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vaccine Connection: Lyme Gets a Business Model")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("49.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter49#ch49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Over and Out, Colorado")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("50.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter50#ch50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Falmouth Reunion")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("51.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter51#ch51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting Dr. Jones")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("52.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter52#ch52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Never-Ending Story: What Happened to My Family")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("53.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter53#ch53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Starting Over: Don’t Get Slymed Again")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("54.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter54#ch54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("And the Bands Play On")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("55.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter55#ch55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Report from the Lymelands, 2009")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("56.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter56#ch56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Report from the Lymelands, 2013")])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes and References")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Pamela Weintraub")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor#ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0